"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const step_styles_1 = require("@/components/indicators/step/step.styles");
require("@/components/common/dot/semantics/current-indicator");
require("@/components/common/text/text");
/**
 * <mm-step-item>
 * 순서 하나를 마커와 라벨로 그리는 단계입니다.
 * 번호와 orientation은 순서에서 나오므로 mm-step이 채우고, 지나온 단계는 active로 표시합니다.
 */
let StepItem = class StepItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        /** @internal 순서를 소유한 mm-step이 채운다. */
        this.orientation = 'horizontal';
        /** @internal 순서를 소유한 mm-step이 채운다. */
        this.value = 1;
        this.label = '';
        this.active = false;
        this.ariaCurrent = null;
        this.hasContent = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'listitem');
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderMarker()} ${this.renderLabel()} ${this.renderCurrentIndicator()}
      ${this.renderContent()}
    `;
    }
    /* 번호는 목록 안에서의 순서를 되풀이하므로 보조기술에는 라벨만 남긴다. */
    renderMarker() {
        return (0, lit_1.html) `
      <span class="marker" aria-hidden="true">${this.value}</span>
    `;
    }
    renderLabel() {
        return (0, lit_1.html) `
      <mm-text class="label">${this.label}</mm-text>
    `;
    }
    renderCurrentIndicator() {
        if (!this.ariaCurrent || this.ariaCurrent === 'false')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-current-indicator></mm-current-indicator>
    `;
    }
    renderContent() {
        return (0, lit_1.html) `
      <div class="content" ?hidden=${!this.hasContent}>
        <slot @slotchange=${this.handleContentSlotChange}></slot>
      </div>
    `;
    }
    handleContentSlotChange(event) {
        const slot = event.target;
        this.hasContent = slot.assignedNodes({ flatten: true }).some(node => {
            if (node.nodeType === Node.TEXT_NODE)
                return !!node.textContent?.trim();
            return true;
        });
    }
};
StepItem.styles = step_styles_1.stepItemStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], StepItem.prototype, "orientation", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], StepItem.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], StepItem.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], StepItem.prototype, "active", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-current', reflect: true })
], StepItem.prototype, "ariaCurrent", void 0);
__decorate([
    (0, decorators_js_1.state)()
], StepItem.prototype, "hasContent", void 0);
StepItem = __decorate([
    (0, decorators_js_1.customElement)('mm-step-item')
], StepItem);
exports.StepItem = StepItem;
//# sourceMappingURL=data:application/json;base64,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